var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDetailExpand = function SvgIconDetailExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon detail-expand",
    viewBox: "0 0 1200 1200",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m342 1200-84-84 516-516-516-516 84-84 600 600z"
  })));
};
export default SvgIconDetailExpand;